import smartBannerConfig from "./smart-banner-config";
import apiConfig from "./api-config";

export default {
  ...apiConfig,
  ...smartBannerConfig,
};
